const usersStyle = {
  tooltip:{
    fontSize:"12px"
  }
};

export default usersStyle


// WEBPACK FOOTER //
// ./src/views/users/style.js